import { Component, OnInit } from '@angular/core';
import {Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-my-business-model',
  templateUrl: './my-business-model.component.html',
  styleUrls: ['./my-business-model.component.scss']
})
export class MyBusinessModelComponent implements OnInit {
  private titleKey: string = "business-model";
  private subtitleKey: string = "business-model-desc";

  constructor(private title: Title, private translate: TranslateService) {
    this.title.setTitle(this.getTitle());
  }

  ngOnInit() {}

  getTitle() {
    return this.translate.instant(this.titleKey);
  }

  getSubtitle() {
    return this.translate.instant(this.subtitleKey);
  }
}
